export const ASSESSOR_ROLE = 'assessor';
export const MANAGER_ROLE = 'manager';
export const ORG_MANAGER_ROLE = 'org manager';
export const LEARNER_ROLE = 'learner';

export const ASSESSOR_LABEL = 'Assessor';
export const MANAGER_LABEL = 'Manager';
export const ORG_MANAGER_LABEL = 'Org Manager';
export const LEARNER_LABEL = 'Learner';

/**
 * ROLES
 *
 * PERMISSION_LEVEL: There aren't official numbers used elsewhere, just here to make comparing permissions easier
 * Higher the level, the more privileges
 */
export const ROLES = {
    MANAGER: {
        API: MANAGER_ROLE,
        LABEL: MANAGER_LABEL,
        PERMISSION_LEVEL: 12
    },
    ASSESSOR: {
        API: ASSESSOR_ROLE,
        LABEL: ASSESSOR_LABEL,
        PERMISSION_LEVEL: 6
    },
    LEARNER: {
        API: LEARNER_ROLE,
        LABEL: LEARNER_LABEL,
        PERMISSION_LEVEL: 2
    },
    ORG_MANAGER: {
        API: ORG_MANAGER_ROLE,
        LABEL: ORG_MANAGER_LABEL,
        PERMISSION_LEVEL: 20
    },
};

ROLES[MANAGER_ROLE] = ROLES.MANAGER;
ROLES[ASSESSOR_ROLE] = ROLES.ASSESSOR;
ROLES[LEARNER_ROLE] = ROLES.LEARNER;
ROLES[ORG_MANAGER_ROLE] = ROLES.ORG_MANAGER;

ROLES[MANAGER_LABEL] = ROLES.MANAGER;
ROLES[ASSESSOR_LABEL] = ROLES.ASSESSOR;
ROLES[LEARNER_LABEL] = ROLES.LEARNER;
ROLES[ORG_MANAGER_LABEL] = ROLES.ORG_MANAGER;

export const USER_ROLES_DROPDOWN_LIST = [
    ROLES.LEARNER.LABEL,
    ROLES.ASSESSOR.LABEL,
    ROLES.MANAGER.LABEL,
    ROLES.ORG_MANAGER.LABEL,
]

/**
 * Checks if lowercase role is valid. Used in CSV import
 * @param  {[type]}  role [description]
 * @return {Boolean}      [description]
 */
export const isValidRole = function(role) {
    return ROLES[role] != null
}